var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"main"},[_c('top-nav'),_c('router-view'),_c('foot-nav'),_c('terms-conditions'),_c('privacy-policy')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scrollUp","title":"Scroll To Top"}},[_c('i',{staticClass:"fas fa-arrow-up"})])
}]

export { render, staticRenderFns }